import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      userSelect: "none",
      cursor: "pointer",
      backgroundColor: theme.goal.portfolio.seemore.background,
      borderRadius: constants.radius.view,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "center",
      width: 76,
      paddingTop: spacing.xxs,
      paddingBottom: spacing.xxs,
      marginBottom: spacing.s,
    },
    text: {
      color: theme.goal.portfolio.seemore.text,
    },
  };

  return styles;
};
